import { adminRequest } from './adminApi'
import type { CreditsBalance, CreditsLedgerTransaction } from './creditsApi'

export interface AdminLedgerParams {
  user_id: string
  limit?: number
  offset?: number
}

export interface AdminCreditsLedger {
  user_id?: string
  transactions: CreditsLedgerTransaction[]
  limit: number
  offset: number
}

export interface AdminTopUpRequest {
  user_id: string
  amount: number
  idempotency_key: string
  note?: string
}

export type RedemptionCodePurpose = 'sale' | 'marketing' | 'test' | 'comp'

export interface AdminGenerateCodesRequest {
  count: number
  amount: number
  purpose?: RedemptionCodePurpose
  expires_at?: number
  note?: string
}

export interface AdminRedemptionCode {
  code: string
  amount?: number
  expires_at?: number
  [key: string]: unknown
}

export interface AdminGenerateCodesResponse {
  codes: AdminRedemptionCode[]
  count: number
}

function ledgerQuery(params: AdminLedgerParams): string {
  const qs = new URLSearchParams()
  qs.set('user_id', params.user_id)
  qs.set('limit', String(params.limit ?? 50))
  qs.set('offset', String(params.offset ?? 0))
  return qs.toString()
}

export const adminBillingApi = {
  balance: (userId: string): Promise<CreditsBalance> =>
    adminRequest<CreditsBalance>(`/v1/credits/balance?user_id=${encodeURIComponent(userId)}`),
  ledger: (params: AdminLedgerParams): Promise<AdminCreditsLedger> =>
    adminRequest<AdminCreditsLedger>(`/v1/admin/credits/ledger?${ledgerQuery(params)}`),
  topUp: (body: AdminTopUpRequest): Promise<CreditsBalance> =>
    adminRequest<CreditsBalance>('/v1/admin/credits/topup', { method: 'POST', body }),
  generateCodes: (body: AdminGenerateCodesRequest): Promise<AdminGenerateCodesResponse> =>
    adminRequest<AdminGenerateCodesResponse>('/v1/admin/credits/codes', { method: 'POST', body }),
}
